import { generateUUID } from '@wix/form-schema';
import { useState, useEffect, useRef } from 'react';
import { FORM_ACTION_STATUS } from '../types';
export const useFormActions = _ref => {
  let {
    wfActions,
    wfResults
  } = _ref;
  const [formActions, setFormActions] = useState({});
  const [inProgress, setInProgress] = useState(false);
  const unresolvedActions = useRef(new Map());
  useEffect(() => {
    if (!wfResults) {
      return;
    }
    unresolvedActions.current.forEach((promiseHandler, actionId) => {
      if (!wfResults[actionId] || wfResults[actionId].status === FORM_ACTION_STATUS.PENDING) {
        setInProgress(true);
        return;
      }
      if (wfResults[actionId].status === FORM_ACTION_STATUS.FAILURE) {
        promiseHandler.reject(wfResults[actionId].result);
      }
      if (wfResults[actionId].status === FORM_ACTION_STATUS.SUCCESS) {
        promiseHandler.resolve(wfResults[actionId].result);
      }
      unresolvedActions.current.delete(actionId);
      setInProgress(unresolvedActions.current.size > 0);
    });
  }, [wfResults]);
  useEffect(() => {
    if (!wfActions) {
      return;
    }
    const actions = Object.entries(wfActions).reduce((acc, _ref2) => {
      let [actionName, actionFunction] = _ref2;
      acc[actionName] = function () {
        const correlationId = generateUUID();
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        actionFunction(correlationId, ...args);
        return new Promise((resolve, reject) => {
          unresolvedActions.current.set(correlationId, {
            resolve,
            reject
          });
        });
      };
      return acc;
    }, {});
    setFormActions(actions);
  }, [wfActions]);
  return {
    formActions,
    inProgress
  };
};
//# sourceMappingURL=use-form-actions.js.map